<px-m0120-text-image
    [image]="image"
    [text]="text"
    [headline]="headline"
    [imageright]="imageright"
></px-m0120-text-image>
